var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeHeartOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8933 1.07749C20.4069 1.10683 18.9636 1.57391 17.7496 2.41846C16.5356 3.26301 15.6067 4.44625 15.0827 5.81546C14.5552 4.43464 13.6222 3.23947 12.4025 2.38203C11.1827 1.5246 9.73132 1.04367 8.233 1.00045C7.33056 0.990123 6.43514 1.15743 5.59936 1.49254C4.76357 1.82765 4.00428 2.3238 3.36612 2.95183C2.72797 3.57986 2.22381 4.3271 1.8833 5.14962C1.54278 5.97215 1.37278 6.85336 1.38327 7.74147C1.38327 16.37 15.0827 26 15.0827 26C15.0827 26 28.743 16.37 28.743 7.74147C28.7431 6.85982 28.5654 5.98693 28.2202 5.17335C27.875 4.35978 27.3692 3.6217 26.7321 3.00188C26.095 2.38205 25.3393 1.8928 24.5087 1.56247C23.6781 1.23214 22.7891 1.0673 21.8933 1.07749Z",
    fill: "url(#paint0_linear_5660_2220)",
    stroke: "url(#paint1_linear_5660_2220)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5660_2220",
    x1: 14.8828,
    y1: -21,
    x2: 15.0629,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.228125,
    stopColor: "#FF0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882792,
    stopColor: "#FF00D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5660_2220",
    x1: 15.0629,
    y1: 1,
    x2: 15.0629,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FF0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FF00D8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeHeartOutline);
export default __webpack_public_path__ + "static/media/like-heart-outline.9dcb383d098353292a03795a28783349.svg";
export { ForwardRef as ReactComponent };